import styled from "styled-components";

import { Autocomplete } from "@similarweb/ui-components";

export const StyledCompanyAutocomplete = styled(Autocomplete)`
    .AutoCompleteContainer {
        padding: 0;
        transform: none;
    }

    .ListItemsContainer {
        max-height: 288px;
        overflow-y: auto;

        &::before {
            display: block;
            z-index: 2;
            height: 0;
            position: sticky;
            top: 0;
            transform: none;
        }
    }
`;

export const StyledCompanyPlaceholderText = styled.span`
    margin-left: 36px;
`;
